module.exports = __webpack_public_path__ + "img/首页底部云存储图.9c7b5ee4.jpg";